// useDebouncedValue — the pool pickers' search debounce: the picker passes its
// live input and the query follows once typing pauses (commit-not-draft,
// ADR-037 §2). A side effect (a timer), not derived state — the no-effect rule is
// about deriving state from props, which this isn't.

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
